import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../../components/DraggableModal";
import { EntTypesOfFertilizers } from "../../../../../models/handBooks/typesOfFertilizers";
import SelectCategoryFertilizers from "../../../../../components/selects/SelectCategoryFertilizers";

enum FormField {
  nameKy,
  nameRu,
  fertilizerCategoryId
}

interface IProps {
  show: boolean;
  typesOfFertilizers: EntTypesOfFertilizers;
  onHide: () => void;
  onSubmit: (pos: EntTypesOfFertilizers) => Promise<boolean>;
}

export const AddTypesOfFertilizers = (props: IProps) => {
  const { t } = useTranslation();
  const [ form ] = useForm();
  const [ loading, setLoading ] = useState<boolean>(false);

  useEffect(() => {
	if (props.show) setFieldsFromEntity();
  }, [ props.show ]);

  const setFieldsFromEntity = (): void => {
	form.setFields([
	  { name: FormField.nameKy, value: props.typesOfFertilizers.nameKy },
	  { name: FormField.nameRu, value: props.typesOfFertilizers.nameRu },
	  { name: FormField.fertilizerCategoryId, value: props.typesOfFertilizers?.fertilizerCategory?.id}
	]);
  }

  const setEntityFromFields = (): EntTypesOfFertilizers => {
	let res = _.cloneDeep(props.typesOfFertilizers);
	res.nameKy = form.getFieldValue(FormField.nameKy);
	res.nameRu = form.getFieldValue(FormField.nameRu);
	res.fertilizerCategoryId = form.getFieldValue(FormField.fertilizerCategoryId);

	return res;
  }

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  const data = setEntityFromFields();
	  const result = await props.onSubmit(data);
	  if (result) props.onHide();
	} finally {
	  setLoading(false);
	}
  }

  return (
	<>
	  <DraggableModal
		title={ props.typesOfFertilizers.id === null ? t('handbooks.types_of_fertilizers.add_types_of_fertilizers') : t('handbooks.types_of_fertilizers.edit_types_of_fertilizers') }
		visible={ props.show }
		onCancel={ props.onHide }
		onSubmit={ handleSubmit }
		submitLoading={ loading }
	  >
		<Form
		  initialValues={ { remember: true } }
		  autoComplete="off"
		  layout="vertical"
		  form={ form }
		>
		  <Form.Item
			label={ t('general.nameKy') }
			name={ FormField.nameKy }
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<Input autoComplete="off"/>
		  </Form.Item>
		  <Form.Item
			label={ t('general.nameRu') }
			name={ FormField.nameRu }
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<Input autoComplete="off"/>
		  </Form.Item>
		  <Form.Item
			label={ t('handbooks.types_of_fertilizers.category_name') }
			name={ FormField.fertilizerCategoryId }
			rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
		  >
			<SelectCategoryFertilizers/>
		  </Form.Item>
		</Form>
	  </DraggableModal>
	</>
  )
}









